<template>
    <div class="main">
        <c-panel title="DOCUMENTOS OBRIGATÓRIOS DA MATRÍCULA" titleIcon="fas fa-file-alt">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Modalidade e nível em branco significam “vale para todos”. Só o documento marcado como bloqueante impede concluir a matrícula."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregar">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" class="u-text-right">
                        <el-button v-if="podeEscrever" size="small" icon="el-icon-plus" class="u-mt-25" @click="adicionar">NOVA REGRA</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table" v-if="periodoId">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 240px;">Documento</th>
                            <th style="width: 200px;">Modalidade</th>
                            <th style="width: 120px;">Nível escolar</th>
                            <th class="u-text-center" style="width: 110px;">Obrigatório</th>
                            <th class="u-text-center" style="width: 130px;">Bloqueia matrícula</th>
                            <th class="u-text-center" style="width: 70px;">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, idx) in linhas" :key="idx">
                            <td>
                                <el-select v-model="l.tipo_documento_anexo_id" filterable size="mini" style="width: 100%;">
                                    <el-option v-for="t in tiposDocumento" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-select v-model="l.modalidade_id" filterable clearable size="mini" placeholder="Todas" style="width: 100%;">
                                    <el-option v-for="m in modalidades" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                                </el-select>
                            </td>
                            <!--
                                Era um input livre com máscara de 2 dígitos: o operador
                                precisava saber de cor que 0 é infantil, 1 é fundamental I e
                                2 é fundamental II, e digitar 3 gravava um nível inexistente
                                que nunca casaria com matrícula alguma. `$CONSTANTS.ETAPA` é
                                a mesma legenda usada no cadastro da matriz curricular.
                            -->
                            <td>
                                <el-select v-model="l.nivel_escolar" clearable size="mini"
                                    placeholder="Todos" style="width: 100%;">
                                    <el-option v-for="(rotulo, v) in $CONSTANTS.ETAPA" :key="v"
                                        :label="rotulo" :value="parseInt(v)"></el-option>
                                </el-select>
                            </td>
                            <td class="u-text-center"><el-checkbox v-model="l.obrigatorio"></el-checkbox></td>
                            <td class="u-text-center"><el-checkbox v-model="l.bloqueia_matricula"></el-checkbox></td>
                            <td class="u-text-center">
                                <el-button v-if="podeEscrever" @click="linhas.splice(idx, 1)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="linhas.length === 0"><td colspan="6" class="u-text-center">Nenhuma regra definida para este período.</td></tr>
                    </tbody>
                </table>
            </div>

            <div class="u-text-right u-mt-20" v-if="podeEscrever && periodoId">
                <el-button type="primary" @click="salvar">SALVAR REGRAS</el-button>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO E — item 7: documentos obrigatórios por modalidade e nível. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        periodoId: null, linhas: [], tiposDocumento: [], modalidades: []
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/documento-matricula-regra/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            const d = r.data || {}
            this.tiposDocumento = d.tipos_documento || []
            this.modalidades = d.modalidades || []
        }).catch(() => {})

        this.carregar()
    },
    methods: {
        carregar () {
            if (!this.periodoId) return
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/documento-matricula-regra/getByPeriodo/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.linhas = (Array.isArray(r.data) ? r.data : []).map(x => Object.assign({}, x, {
                    obrigatorio: !!x.obrigatorio, bloqueia_matricula: !!x.bloqueia_matricula
                }))
            }).catch(e => this.$store.commit('throwException', e))
        },
        adicionar () {
            this.linhas.push({ tipo_documento_anexo_id: null, modalidade_id: null, nivel_escolar: null,
                obrigatorio: true, bloqueia_matricula: false, situacao: true })
        },
        salvar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/documento-matricula-regra/salvarLote`,
                { periodo_letivo_id: this.periodoId, itens: this.linhas },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
